module.exports = __webpack_public_path__ + "img/logo-shuanglu.b9973b08.png";